<template>
  <div class="col-12 bg-white mb-3 card-border p-4 z-index-2 mx-auto">
    <div class="row" v-if="result === null">
      <div class="col-12">
        <div>
          <div class="d-md-none">
            <h2 class="h3 font-Pr7 text-center my-3 d-md-none text-secondary1">
              Calculador de calorías
            </h2>
            <p class="p-sm pt-2 text-secondary1">
              La edad, el peso, la altura y la actividad física son claves para definir una dieta sana.<br />Ingresá tus
              datos para obtener un estimado de las calorías que tu cuerpo necesita.
            </p>
          </div>
          <div class="row justify-content-center d-none d-md-flex">
            <div class="col-10 d-block text-center w-100">
              <h2 class="h3 font-Pr7 text-center my-3 text-secondary1">
                Calculador de calorías
              </h2>
              <p class="pt-2 font-Pr4 text-secondary1">
                La edad, el peso, la altura y la actividad física son claves para definir una dieta sana.<br />Ingresá
                tus
                datos para obtener un estimado de las calorías que tu cuerpo necesita.
              </p>
            </div>
          </div>
        </div>
        <div class="row mx-0 justify-content-center">
          <div class="col-md-8 p-0">
            <form @submit.prevent="getCalculation">
              <div class="row mx-0 justify-content-center">
                <div class="col-md-12 col-lg-10 px-0">
                  <div class="py-3 custom-grid w-100">
                    <div class="div-data sex">
                      <label class="label-sm font-Pr4 text-black">Sexo:</label>
                      <Multiselect v-model="formUser.gender" :options="[
                        { value: 1, name: 'Masculino' },
                        { value: 2, name: 'Femenino' }
                      ]" label="name" track-by="value" placeholder="Seleccionar" class="p-0 sex-multiselect" />
                      <small class="text-red">{{ errors.gender }}</small>
                    </div>

                    <div class="div-data age">
                      <label class="label-sm font-Pr4 text-black">Edad:</label>
                      <div class="multi-div">
                        <input type="number" v-model="formUser.age" placeholder="Ej: 35"
                          class="form-control age-input" />
                        <div class="ms-cc font-AR">
                          <span class="sp-a">Años</span>
                        </div>
                      </div>
                      <small class="text-red">{{ errors.age }}</small>
                    </div>

                    <div class="div-data weight">
                      <label class="label-sm font-Pr4 text-black">Peso:</label>
                      <div class="multi-div">
                        <input type="number" v-model="formUser.weight" placeholder="Ej: 76"
                          class="form-control weight-input" />
                        <div class="ms-cc kgs font-AR">
                          <span class="sp-kg">Kgs</span>
                        </div>
                      </div>
                      <small class="text-red">{{ errors.weight }}</small>
                    </div>

                    <div class="div-data height">
                      <label class="label-sm font-Pr4 text-black">Altura:</label>
                      <div class="multi-div">
                        <input type="number" v-model="formUser.height" placeholder="Ej: 179"
                          class="form-control height-input" />
                        <div class="ms-cc cms font-AR">
                          <span class="sp-cms">
                            Cms
                          </span>
                        </div>
                      </div>
                      <small class="text-red">{{ errors.height }}</small>
                    </div>
                  </div>
                </div>

              </div>

              <div class="row mx-0 justify-content-left justify-content-md-center">
                <div class="pt-3 col-md-8 px-0 text-md-center">
                  <p class="h4 font-Pr7 mb-3 text-secondary1">
                    Cantidad de ejercicio semanal
                  </p>
                  <div class="row py-3 justify-content-center mx-0">
                    <div class="col-md-10 col-lg-8 px-0">
                      <div class="w-fit-content">
                        <div v-for="(option, index) in exerciseOptions" :key="index" class="form-check mb-3">
                          <input class="form-check-input" type="radio" :id="'radio-' + index" :value="option.value"
                            v-model="formExercise" />
                          <label class="form-check-label font-Pr4 text-black" :for="'radio-' + index">
                            {{ option.label }}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="text-center">
                <button class="btn btn-outline-primary my-3 font-A12 h-50-px text-uppercase custom-width" type="submit"
                  :disabled="!isFormValid">
                  <strong>Calcular</strong>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div class="row" v-else>
      <div class="col-12 text-center">
        <span class="h4 font-P20 d-block text-primary2 my-3">Tu cuerpo necesita:</span>
        <span class="h1 font-Pr7 d-block mb-3 text-black">{{ result.toFixed(2) }} kcal.</span>
        <span class="h3 font-Pr7 d-block text-black">por día</span>
        <button class="mt-4 btn btn-outline-primary font-A12 text-uppercase h-50-px w-289" @click="onReset()">
          Calcular nuevamente
        </button>
      </div>
      <div class="col-12">
        <p class="text-primary h4 font-Pr7 mt-5 mb-3">
          ¿Qué significa este dato?
        </p>
        <p class="p-sm font-Pr text-black">
          Las calorías son las sustancias encargadas de aportar energía al
          organismo. Éstas se miden mediante una unidad denominada caloría. Cuando
          se consume un producto, el cuerpo absorbe y metaboliza los nutrientes.
          Es en este proceso donde se obtiene la energia.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from '@vueform/multiselect';
import '@vueform/multiselect/themes/default.css';

export default {
  components: {
    Multiselect
  },
  data() {
    return {
      formUser: {
        gender: null,
        age: null,
        height: null,
        weight: null
      },
      formExercise: 0,
      result: null,
      errors: {
        gender: '',
        age: '',
        height: '',
        weight: ''
      },
      exerciseOptions: [
        { value: 0, label: 'Sin ejercicio' },
        { value: 1, label: '1 - 2 días a la semana' },
        { value: 2, label: '3 - 4 días a la semana' },
        { value: 3, label: '5 - 6 días a la semana' },
        { value: 4, label: '6 - 7 días a la semana' }
      ]
    }
  },
  computed: {
    isFormValid() {
      return (
        this.formUser.gender !== null &&
        this.formUser.age !== null &&
        this.formUser.height !== null &&
        this.formUser.weight !== null &&
        this.formExercise !== null
      );
    }
  },
  methods: {
    getCalculation() {
      const TMB =
        this.formUser.weight * 10 +
        this.formUser.age * 5 +
        this.formUser.height * 6.25 +
        (this.formUser.gender === 1 ? 5 : -161);

      const result =
        this.formExercise === 0
          ? TMB * 1.2
          : this.formExercise === 1
            ? TMB * 1.375
            : this.formExercise === 2
              ? TMB * 1.55
              : this.formExercise === 3
                ? TMB * 1.725
                : TMB * 1.9;

      this.result = result;
    },
    validateForm() {
      this.errors.gender = this.formUser.gender ? '' : 'Sexo es requerido';
      this.errors.age = this.formUser.age >= 0 ? '' : 'Edad es requerida';
      this.errors.weight = this.formUser.weight >= 0 ? '' : 'Peso es requerido';
      this.errors.height = this.formUser.height >= 0 ? '' : 'Altura es requerida';
    },
    onReset() {
      this.result = null;
      this.formUser = {
        gender: null,
        age: null,
        height: null,
        weight: null
      };
      this.formExercise = 0;
      this.errors = {
        gender: '',
        age: '',
        height: '',
        weight: ''
      };
    }
  }
}
</script>

<style lang="scss" scoped>
.multi-div {
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  width: 100%;
}

.form-control {
  &::placeholder {
    color: rgba(109, 109, 109, 0.4) !important;
  }

  &::-webkit-input-placeholder {
    color: rgba(109, 109, 109, 0.4) !important;
  }

  &:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: rgba(109, 109, 109, 0.4) !important;
  }

  &::-ms-input-placeholder {
    /* Microsoft Edge */
    color: rgba(109, 109, 109, 0.4) !important;
  }
}

.custom-grid {
  @media (min-width: 768px) {
    grid-row-gap: 20px;
    grid-column-gap: 20px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(2, 100px);
  }

  @media (max-width:767px) {
    grid-template-rows: repeat(4, 100px);
    grid-template-columns: repeat(1, 1fr);
    display: grid;
  }
}

.custom-user-borders {
  border-top: 1px solid #dee2e6;
  border-bottom: 1px solid #dee2e6;
  border-right: 1px solid #dee2e6;
  border-radius: 0 8px 8px 0;
}
</style>